module.exports = __webpack_public_path__ + "img/wxUrl.b944a745.png";